
  export default {
    name: 'About',
    created(){
        document.title = "Tumi | Website - Apps - Advertising"
    }
  }
